import { render } from "./agenda.vue?vue&type=template&id=6a33a6ae&scoped=true"
import script from "./agenda.vue?vue&type=script&lang=js"
export * from "./agenda.vue?vue&type=script&lang=js"

import "./agenda.vue?vue&type=style&index=0&id=6a33a6ae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6a33a6ae"

export default script